import React, { useState } from "react";
import PropTypes from "prop-types";
import { DmsTextFieldMasked, intl } from "dmsbasereact";

// Mask function for CRF (only numbers, max 6 digits)
const CrfMask = (value) => {
  value = value.replace(/\D/g, ""); // remove non-numeric
  return value.slice(0, 6); // max 6 digits
};

// Validation function for CRF (accepts 5 or 6 digits)
const isValidCRF = (value) => {
  const num = value.replace(/\D/g, "");
  return num.length >= 5 && num.length <= 6;
};

export const TextFieldCrf = ({
  name = "crf",
  label = "CRF",
  placeholder = "Enter CRF",
  validateOnBlur = true,
  validateOnChange = false,
  onValidationChange,
  error: externalError,
  helperText: externalHelperText,
  ...props
}) => {
  const [internalError, setInternalError] = useState(false);
  const [internalHelperText, setInternalHelperText] = useState("");

  // External error/helperText takes priority over internal validation
  const error = externalError || internalError;
  const helperText = externalHelperText || internalHelperText;

  const handleValidation = (value) => {
    if (!value) {
      setInternalError(false);
      setInternalHelperText("");
      onValidationChange?.(true);
      return;
    }

    const valid = isValidCRF(value);
    setInternalError(!valid);
    setInternalHelperText(valid ? "" : intl.get("InvalidCRF").d("Invalid CRF (must be 5 or 6 digits)"));
    onValidationChange?.(valid);
  };

  const handleBlur = (event) => {
    if (validateOnBlur) handleValidation(event.target.value);
  };

  const handleChange = (event) => {
    if (validateOnChange) handleValidation(event.target.value);
    props.onChange?.(event);
  };

  return (
    <DmsTextFieldMasked
      name={name}
      label={label}
      placeholder={placeholder}
      maskFunction={CrfMask}
      error={error}
      helperText={helperText}
      onBlur={handleBlur}
      onChange={handleChange}
      {...props}
    />
  );
};

TextFieldCrf.propTypes = {
  validateOnBlur: PropTypes.bool,
  validateOnChange: PropTypes.bool,
  onValidationChange: PropTypes.func,
};
